/**
 * UI « file d’attente payante » : montants à la suggestion, boost, onglet collecte, podium €, etc.
 *
 * Variables Vite (client) :
 * - `VITE_ENABLE_PAID_FEATURES` : préféré (`false` / `0` / `no` / `off` = masquer toute cette UI).
 * - `VITE_ENABLE_POURBOIRES` : alias historique, même logique si la première est absente.
 *
 * Absent ou vide → tout affiché (comportement par défaut).
 */
function isExplicitlyDisabled(value) {
  if (value === undefined || value === '') return false;
  const s = String(value).trim().toLowerCase();
  return s === 'false' || s === '0' || s === 'no' || s === 'off';
}

export function isPaidQueueUiEnabled() {
  if (isExplicitlyDisabled(import.meta.env.VITE_ENABLE_PAID_FEATURES)) return false;
  if (isExplicitlyDisabled(import.meta.env.VITE_ENABLE_POURBOIRES)) return false;
  return true;
}
